<template>
  <div>
    <b-card>
      <label class="text--topic mb-1">Generate Report</label>
      <div class="d-flex flex-column flex-lg-row mb-2">
        <div class="col-12 col-lg-6 p-0 pr-lg-1">
          <label>Generate Report for</label>
          <atom-select
            v-model="selectedModule"
            label="title"
            placeholder="Generate Report for"
            class="organism-report--generate-report--container-select"
            :option="moduleOptions"
            :isClearable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
          >
          </atom-select>
        </div>
        <div class="col-12 col-lg-6 p-0 pl-lg-1 mt-1 mt-lg-0">
          <molecule-date-picker-period
            titleStart="Start Date"
            titleEnd="End Date"
            type="dateNtime"
            v-model="datepicker"
            :maxDate="datepicker.end"
            :minDate="datepicker.start"
            :dateNow="datepicker.now"
          ></molecule-date-picker-period>
        </div>
      </div>

      <hr />

      <div v-if="selectedModule.value === 'SMS'" class="row">
        <div class="col-12 text--topic mb-1">Select Data</div>
        <div class="col-12 mb-1">
          <label>Equipment Name</label>
          <atom-multi-select
            v-model="selectedEquipmentList"
            class="w-100"
            label="name"
            placeholder="All Equipments"
            :option="equipmentList"
            :isAppendToBody="false"
            :isEnableProper="false"
          ></atom-multi-select>
        </div>

        <div class="col-12 col-lg-6">
          <label>Tag</label>
          <atom-multi-select
            v-model="selectedTagList"
            :option="tagList"
            :isDisable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            placeholder="All Tags"
          ></atom-multi-select>
        </div>

        <div class="col-12 col-lg-6 mt-1 mt-lg-0">
          <label>Resource Type</label>
          <atom-multi-select
            v-model="selectedResourceList"
            :option="resourceList"
            :isDisable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            placeholder="All Resource Types"
          ></atom-multi-select>
        </div>
      </div>
      <div
        class="col-12 d-flex align-items-start justify-content-center justify-content-md-end margin-top-23px px-0"
      >
        <atom-button
          buttonId="organism-report-button-review"
          buttonStyle="flat"
          buttonColor="primary"
          class="organism-report--button-review"
          @click="clickButtonReview"
        >
          <feather-icon icon="EyeIcon" size="14" class="mr-1"></feather-icon>
          <span>Review</span>
        </atom-button>
        <atom-button
          buttonId="organism-report-button-export"
          class="organism-report--generate-report--button-export"
          @click="clickButtonExport"
        >
          <feather-icon
            icon="ExternalLinkIcon"
            size="14"
            class="mr-1"
          ></feather-icon>
          <span>Export</span>
        </atom-button>
      </div>
    </b-card>
    <div v-if="isFilter" class="organism-report--data-table--card">
      <div class="organism-report--data-table--container">
        <molecule-data-table
          v-model="inputSearch"
          :fields="fields"
          :items="items"
          :isCustomized="true"
          :enabledSelect="false"
          :enabledSearch="true"
          :isShowPagination="true"
          placeholderSearch="Filter Events"
          maxHeight="568px"
        >
          <template #leftOfSearch>
            <label class="organism-report--data-table--topic">Preview</label>
          </template>
          <template #time="data">
            <span class="text--normal pl-1">{{ data.row.date }}</span> <br />
            <span class="text--light pl-1">{{ data.row.time }}</span>
          </template>
          <template #equipment="data">
            <div class="d-flex">
              <span class="text--bold">{{ data.row.equipmentName }}</span>
              <div :id="'tag-popover' + data.row.originalIndex">
                <feather-icon
                  icon="TagIcon"
                  size="12"
                  class="tag-icon--style"
                />
              </div>
              <b-popover
                ref="popover"
                :target="'tag-popover' + data.row.originalIndex"
                triggers="hover"
                placement="right"
                container="my-container"
                boundary="window"
              >
                <template v-slot:title>
                  <div class="d-flex justify-content-between align-items-left">
                    <span>Tag</span>
                  </div>
                </template>
                <div class="badge__container">
                  <b-badge
                    v-for="(tag, index) in data.row.tag"
                    :key="index"
                    variant="light-primary"
                    class="badge--style tag--space"
                  >
                    {{ tag }}
                  </b-badge>
                </div>
              </b-popover>
            </div>

            <span class="text--light">{{ data.row.equipmentIp }}</span>
          </template>
          <template #resources="data">
            <b-badge
              pill
              :variant="badgeVariant(data.row.status)"
              class="badge--width"
            >
              {{ data.row.resources }}
            </b-badge>
          </template>
          <template #value="data">
            <div class="value__container">
              <div
                class="text--normal text--width mr-1 d-flex justify-content-end"
              >
                {{ data.row.value + " " + policyUnit(data.row.unit) }}
              </div>
              <div :id="'alert-icon' + data.row.originalIndex">
                <feather-icon
                  icon="AlertTriangleIcon"
                  class="alert__icon--active"
                />
              </div>
              <b-tooltip
                :target="'alert-icon' + data.row.originalIndex"
                placement="right"
                boundary="window"
                variant="warning"
              >
                <div class="textbox__warning-value--style">
                  <span>Warning</span>
                  <span>{{
                    data.row.warningValue
                      ? data.row.warningValue + " " + policyUnit(data.row.unit)
                      : "-"
                  }}</span>
                </div>
                <div class="textbox__danger-value--style">
                  <span>Critical</span>
                  <span>{{
                    data.row.criticalValue
                      ? data.row.criticalValue + " " + policyUnit(data.row.unit)
                      : "-"
                  }}</span>
                </div>
              </b-tooltip>
            </div>
          </template>
          <template #description="data">
            {{ data.row.description }}
          </template>
        </molecule-data-table>
      </div>
    </div>
    <footer style="height: 28px"></footer>
  </div>
</template>

<script>
import { BCard, BBadge, BPopover, VBTooltip, BTooltip } from "bootstrap-vue"
import Ripple from "vue-ripple-directive"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import AtomMultiSelect from "@/components/atoms/AtomMultiSelect.vue"
import MoleculeDatePickerPeriod from "@/components/molecules/MoleculeDatePickerPeriod.vue"
import MoleculeRadioSelectData from "@/components/molecules/MoleculeRadioSelectData.vue"
import MoleculeDataTable from "@/components/molecules/MoleculeDataTable.vue"
import mixinsDateTime from "@/mixins/mixinsDatetime"

export default {
  name: "OrganismReport",
  components: {
    BCard,
    AtomButton,
    AtomSelect,
    AtomMultiSelect,
    MoleculeDatePickerPeriod,
    MoleculeRadioSelectData,
    MoleculeDataTable,
    BBadge,
    BPopover,
    VBTooltip,
    BTooltip,
  },
  mixins: [mixinsDateTime],
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  props: {
    moduleOptions: {
      type: Array,
      required: true,
    },
    resourceList: {
      type: Array,
      required: false,
    },
    equipmentList: {
      type: Array,
      required: true,
    },
    tagList: {
      type: Array,
      required: true,
    },
    isFilter: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: Object,
      required: true,
    },
    fields: {
      type: Array,
      required: false,
      default: [],
    },
    items: {
      type: Array,
      required: false,
      default: [],
    },
  },
  emits: ["clickReview", "clickExport"],
  data() {
    return {
      selectedModule: this.moduleOptions[0],
      selectedEquipmentList: [],
      selectedTagList: [],
      selectedResourceList: [],
      inputSearch: "",
    }
  },
  computed: {
    datepicker: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
  },
  methods: {
    // review
    clickButtonReview() {
      const filter = {
        from: this.removeTimeZone(this.datepicker.start),
        to: this.removeTimeZone(this.datepicker.end),
        tags: this.selectedTagList.length ? this.selectedTagList : this.tagList,
        equipments: this.selectedEquipmentList.length
          ? this.selectedEquipmentList
          : this.equipmentList,
        resourceTypes: this.selectedResourceList,
      }
      this.$emit("clickReview", filter)
    },

    // export
    clickButtonExport() {
      const filter = {
        from: this.removeTimeZone(this.datepicker.start),
        to: this.removeTimeZone(this.datepicker.end),
        tags: this.selectedTagList.length ? this.selectedTagList : this.tagList,
        equipments: this.selectedEquipmentList.length
          ? this.selectedEquipmentList
          : this.equipmentList,
        resourceTypes: this.selectedResourceList,
      }
      this.$emit("clickExport", filter)
    },

    policyUnit(unit) {
      if (unit.toLowerCase() !== "percent") return unit
      else return "%"
    },
    badgeVariant(status) {
      if (status === 0) return "light-primary"
      else if (status === 1) return "light-warning"
      else return "light-danger"
    },
  },
}
</script>

<style lang="scss" scoped>
.text--topic,
.organism-report--data-table--topic {
  font-weight: 500;
  font-size: 18px;
  color: #5e5873;
}

.organism-report--generate-report--selectNdatepicker-container {
  display: block;
  margin-top: 27px;
}

.organism-report--generate-report--select-container {
  width: 100%;
}

.organism-report--generate-report--datepicker-container {
  width: 100%;
}

.organism-report--generate-report--radioSelect-container {
  display: block;
}

.organism-report--generate-report--button-container {
  display: flex;
  justify-content: right;
  margin-top: 10px;
}

.organism-report--generate-report--button-export {
  margin-left: 20px;
}

.text--width {
  width: 75px;
}

.margin-top-23px {
  margin-top: 23px;
  height: 38px;
}

.organism-report--data-table--card {
  overflow: hidden;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
}

.organism-report--data-table--topic {
  margin-bottom: 10px;
}

.data-table__id--style {
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #7367f0;
}

.data-table__icon-div--style {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  background-color: #edeeef;
  width: 30px;
  border-radius: 50%;
}

.data-table__icon--style {
  color: #7367f0;
  height: 14px;
  width: 14px;
}

.data-table__balance--style-paid {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  width: 50px;
  border-radius: 17px;
  font-size: 12px;
  font-weight: 600;
  color: #28c76f;
  background-color: #e5f8ee;
}

tr:last-child {
  border-bottom: none !important;
}

.container__footer {
  padding: 1.5rem;
}

.text--entries {
  padding-left: 10px;
  font-size: 14px;
}

.text--topic {
  font-weight: 500;
  font-size: 18px;
}

.text--bold {
  font-weight: 600;
  font-size: 14px;
}

.text--normal {
  font-weight: 400;
  font-size: 14px;
}

.text--light {
  color: #b9b9c3;
  font-weight: 400;
  font-size: 12px;
}

.tag-icon--style {
  color: #9d95f5;
  margin-left: 8px;
  margin-bottom: 3px;
}

.badge__container {
  min-width: 200px;
  width: auto;
}

.badge--style {
  max-width: 30ch;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tag--space {
  margin-left: 4px;
  margin-bottom: 4px;
}

.value__container {
  display: flex;
}

.alert__icon--style {
  margin-bottom: 5px;
  color: #fff;
}

.alert__icon--active {
  color: #b9b9c3;
}

.textbox__warning-value--style {
  display: flex;
  justify-content: space-between;
  color: #ff9f43;
  font-weight: 400;
  font-size: 14px;
}

.textbox__danger-value--style {
  display: flex;
  justify-content: space-between;
  color: #ea5455;
  font-weight: 400;
  font-size: 14px;
}

.badge--width {
  width: 75px;
}

.organism-report--data-table--card ::v-deep {
  .molecule-datatable--header-search-container {
    display: block;
    padding: 0 1.5rem 0 1.5rem;
    margin-top: 25px;
  }
  .molecule-datatable--pagination {
    display: flex;
    justify-content: center;
    padding: 0 26px;
  }
}

.organism-report--button-review:focus {
  background-color: #ffffff;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
  .organism-report-- {
    &generate-report-- {
      &topic {
        font-size: 18px;
      }
      &selectNdatepicker- {
        &container {
          display: flex;
          margin-top: 27px;
          flex-wrap: wrap;
        }
      }
      &select- {
        &container {
          width: 334px;
          margin-right: 70px;
        }
      }
      &datepicker- {
        &container {
          width: 576px;
        }
      }
      &radioSelect- {
        &container {
          display: flex;
        }
      }
    }
  }
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
  .organism-report--data-table--topic {
    margin-bottom: 0;
  }
  .organism-report--data-table--card ::v-deep {
    .molecule-datatable--header-search-container {
      display: flex;
      justify-content: space-between;
      padding: 0 1.5rem 0 1.5rem;
      padding-right: 24px;
      margin-top: 15px;
    }
    .molecule-datatable--pagination {
      display: flex;
      justify-content: space-between;
      padding: 0 26px;
    }
  }
  .select-equipment__width {
    width: 978px;
  }
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
